'use strict';
import angular from 'angular';

angular.module('product.categories.services', [])

    .factory('ProductCategoriesService', ['IORestangular', '$q', function (IORestangular, $q) {
        var categories = IORestangular.all('products/productCategories');
        var category = IORestangular.all('products/productCategory');
        var categoryProducts = IORestangular.all('products/productsForCategory');

        var getCategories = function () {
            return categories.getList();
        };

        var addCategory = function (categoryObj) {
            return category.customPOST(categoryObj, undefined, undefined, undefined);
        }

        var updateCategory = function (categoryObj) {
            return category.customPUT(undefined, undefined, categoryObj, undefined);
        };

        var deleteCategory = function (categoryObj) {
            return category.remove(categoryObj);
        };

        var getCategoryProducts = function (categoryId) {
            return categoryProducts.getList({categoryId: categoryId });
        };

        var updateCategoryProducts = function (categoryObj) {
            return categoryProducts.customPUT(categoryObj, undefined, undefined, undefined);
        };

        return {
            getCategories: getCategories,
            addCategory: addCategory,
            updateCategory: updateCategory,
            deleteCategory: deleteCategory,
            getCategoryProducts: getCategoryProducts,
            updateCategoryProducts: updateCategoryProducts
        };
    }]);